export default __webpack_public_path__ + "static/media/background.1c39203d.png";